import React from "react";
import { Typography, Box, Button, Stack } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import ListAltIcon from "@mui/icons-material/ListAlt";
import * as XLSX from "xlsx";
import { exportContactsToXLSX } from "../../list-manager/functions";

export default function TemplateFormat() {
  const onDownload = () => {
    exportContactsToXLSX([], "Contacts_Template.xlsx");
  };

  return (
    <Box sx={{ background: "#ededed", borderRadius: 2, padding: 2 }}>
      <Stack
        flexDirection="row"
        gap={1}
        alignItems="center"
        marginBottom={1}
        paddingLeft={0.5}
      >
        <ListAltIcon />
        <Typography style={{ fontWeight: "bold", fontSize: 14 }}>
          CSV/Excel Template Format
        </Typography>
      </Stack>
      <Typography style={{ fontSize: 12, paddingLeft: 5 }}>
        Required Columns: Household ID, Assigned Agent
      </Typography>
      <Button startIcon={<DownloadIcon />} onClick={onDownload}>
        Download Template
      </Button>
    </Box>
  );
}